import { useMemo, useState } from "react";
import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import GalleryGrid from "../components/GalleryGrid";
import CTASection from "../components/CTASection";
import { galleryImages, galleryFilters } from "../data/gallery";

export default function GalleryPage() {
  const [filter, setFilter] = useState("All");
  const items = useMemo(
    () =>
      filter === "All"
        ? galleryImages
        : galleryImages.filter((g) => g.category === filter),
    [filter],
  );

  return (
    <>
      <SEO
        title="Salon Gallery | Glow & Blow Banjara Hills"
        description="A look inside Glow & Blow Unisex Salon, Banjara Hills — salon spaces, hair, styling and beauty moments."
      />
      <PageHero
        eyebrow="Gallery"
        titleLines={[
          <>The Salon,</>,
          <>
            In <em className="italic text-champagne">Frames</em>
          </>,
        ]}
        copy="A glimpse of the space, the craft and the details. Stock photography shown as placeholder — authentic salon photography coming soon."
      />

      <section className="pb-24 md:pb-32" data-testid="gallery-page">
        <div className="container-x">
          <div
            className="mb-12 flex flex-wrap gap-2"
            role="group"
            aria-label="Filter gallery by category"
          >
            {galleryFilters.map((f) => (
              <button
                key={f}
                type="button"
                data-testid={`gallery-filter-${f.toLowerCase()}`}
                aria-pressed={filter === f}
                onClick={() => setFilter(f)}
                className={`min-h-[44px] border px-5 text-[12px] font-semibold uppercase tracking-[0.14em] transition-colors duration-300 ${
                  filter === f
                    ? "border-ink bg-ink text-white"
                    : "border-line bg-transparent text-soften hover:border-ink hover:text-ink"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
          <GalleryGrid items={items} />
        </div>
      </section>

      <CTASection />
    </>
  );
}
